export enum rolesPageActionTypes {
  SET_IS_OPEN_ROLE_DELETE_MODAL = 'SET_IS_OPEN_ROLE_DELETE_MODAL',
}
